import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Constants } from 'app/shared/shared-constants';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { ColumnType } from 'app/shared/utils/column-type.util';

export const azureDataExplorerTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.azureDataExplorer.datasetType,
    displayName: __IS_FABRIC_DPE__ ? stringResources.AzureDataExplorer_DisplayText : stringResources.AzureDataExplorer_DisplayText_old,
    supportLinkedServiceTypes: [adfModelTypeMap.azureDataExplorer.linkedServiceType],
    isSource: true,
    isSink: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-azure_data_explorer'
    },
    isFirstClass: true,
    tableNameDisplay: stringResources.ModelName_Table,
    tableNamePlural: stringResources.Tables,
    category: ['Azure'],
    supportCreatedAsV2: true,
    supportDataFlowSink: true,
    supportDataFlowSource: true,
    v1SupportSchema: true,
    copySourceControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'queryTimeout',
                label: stringResources.ModelName_Source_QueryTimeout,
                description: stringResources.Timeout_DescriptionMessage,
                validators: [
                    {
                        type: 'pattern',
                        pattern: Constants.timeoutValidationPattern,
                        errorMessage: format(stringResources.InvalidTimeoutPattern, stringResources.ModelName_Source_QueryTimeout)
                    }
                ]
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'checkbox',
                bind: 'noTruncation',
                label: stringResources.ModelName_NoTruncation,
                defaultValue: true,
                description: stringResources.NoTruncation_Description,
                labelPosition: 'left'
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    copySinkControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'textbox',
                bind: 'ingestionMappingName',
                label: stringResources.ModelName_IngestionMappingName,
                description: stringResources.AzureDataExplorerIngestionMappingNameDescription,
                descriptionLink: 'https://docs.microsoft.com/azure/data-factory/connector-azure-data-explorer#azure-data-explorer-as-sink'
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'parameterizable',
            child: {
                type: 'complex-object-container',
                bind: 'additionalProperties',
                label: stringResources.ModelName_AdditionalPropertiesName,
                description: stringResources.ModelName_AdditionalPropertiesName_Desc + '<a target="_blank" href="https://docs.microsoft.com/azure/data-explorer/ingestion-properties">'
                    + stringResources.LearnMore + '</a>',
                escapeDescription: false,
                doNotParseValueIntoObjectWithNonObjectTypeSetting: true,
                stringifyArrays: true
            }
        }
    ],
    PhysicalToLogicalMapping: {
        // eslint-disable-next-line id-blacklist
        string: ColumnType.String,
        int: ColumnType.Int32,
        long: ColumnType.Int64,
        bool: ColumnType.Boolean,
        real: ColumnType.Double,
        decimal: ColumnType.Decimal,
        datetime: ColumnType.DateTime,
        timespan: ColumnType.TimeSpan,
        guid: ColumnType.Guid,
        dynamic: ColumnType.String
    },
    copyJob: {
        multipleQuery: true
    }
};
